import React, { useEffect, useState } from 'react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

/* React Bootstrap imports */
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card"
import Form from "react-bootstrap/Form";

import { fetchGET, fetchPOST1 } from "../apiHelper";
import { izvozProjektov, izvozPartnerjev, izvozObcanskaZnanost, izvozObcanskaZnanostSodelujoceOsebe, izvozObcanskaZnanostSkrbnik, izvozObcanskaZnanostVsi, claniceUM } from "../listOfApi";

import SpinnerLoading from './SpinnerLoading';
import { CodeChallengeMethodValues } from '@azure/msal-common';

import Select from "react-select";

const Reports = () => {
    const [reportButtonDisabled, setReportButtonDisabled] = useState(false);
    
    const [showSpinnerLoading, setShowSpinnerLoading] = useState(false);
    const [showSpinnerLoadingPartnerji, setShowSpinnerLoadingPartnerji] = useState(false);
    const [sifrantClanice, setSifrantClanice] = useState([]);

    const [showSpinnerLoadingOZ1, setShowSpinnerLoadingOZ1] = useState(false);
    const [showSpinnerLoadingOZ2, setShowSpinnerLoadingOZ2] = useState(false);
    const [showSpinnerLoadingOZ3, setShowSpinnerLoadingOZ3] = useState(false);
    const [showSpinnerLoadingOZ4, setShowSpinnerLoadingOZ4] = useState(false);
    
    const [showNoDataOZ1, setShowNoDataOZ1] = useState(false);
    const [showNoDataOZ2, setShowNoDataOZ2] = useState(false);
    const [showNoDataOZ3, setShowNoDataOZ3] = useState(false);
    const [showNoDataOZ4, setShowNoDataOZ4] = useState(false);
    
    const [obcanskaZnanostInput, setObcanskaZnanostInput] = useState({
        clanica: "",
        datumOD: "",
        datumDO: "",
    });
    const [obcanskaZnanostSodelujoceOsebeInput, setObcanskaZnanostSodelujoceOsebeInput] = useState({
        datumOD: "",
        datumDO: "",
    });
    const [obcanskaZnanostSkrbnikInput, setObcanskaZnanostSkrbnikInput] = useState({
        datumOD: "",
        datumDO: "",
    });
     const [obcanskaZnanostVsiInput, setObcanskaZnanostVsiInput] = useState({
        datumOD: "",
        datumDO: "",
    });

    useEffect(() => {
        fetchGET(claniceUM).then((sifranti) => {
            if (sifranti !== 0) {
                let sifrant1 = sifranti.map((sifrant) => {
                    return { label: sifrant.naziv, value: sifrant.id };
            });
            setSifrantClanice(sifrant1);
            }
        });
    }, [obcanskaZnanostInput]);

    const exportXlsxProjectsAll = () => {
        setShowSpinnerLoading(true);
        setReportButtonDisabled(true);

        fetchGET(
            `${izvozProjektov}`
        ).then((izvozProjektov) => {
            if (izvozProjektov !== 0) {
                //GET API KLIC PODATKE IN EXPORTAJ
                const fileType =
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const fileExtension = '.xlsx';

                const ws = XLSX.utils.json_to_sheet(izvozProjektov);
                const wb = { Sheets: { projekti: ws }, SheetNames: ['projekti'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });
                FileSaver.saveAs(data, 'izvoz_projektov' + fileExtension);

                setShowSpinnerLoading(false);
                setReportButtonDisabled(false);

            } else {
            }
        });
    }

    const exportXlsxProjectsPartners = () => {
        setShowSpinnerLoadingPartnerji(true);
        setReportButtonDisabled(true);

        fetchGET(
            `${izvozPartnerjev}`
        ).then((partnerjiIzvoz) => {
            if (partnerjiIzvoz !== 0) {

                //GET API KLIC PODATKE IN EXPORTAJ
                const fileType =
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const fileExtension = '.xlsx';

                const ws = XLSX.utils.json_to_sheet(partnerjiIzvoz);
                const wb = { Sheets: { partnerjiProjekti: ws }, SheetNames: ['partnerjiProjekti'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });
                FileSaver.saveAs(data, 'izvoz_partnerjevProjektov' + fileExtension);

                setShowSpinnerLoadingPartnerji(false);
                setReportButtonDisabled(false);

            } else {
            }
        });
    }

    const exportXlsxObcanskeZnanosti = () => {
        fetchPOST1(`${izvozObcanskaZnanost}`, obcanskaZnanostInput)
        .then((data1) => {
            setShowSpinnerLoadingOZ1(true);
            setReportButtonDisabled(true);

            if (data1 !== 0) {

                //GET API KLIC PODATKE IN EXPORTAJ
                const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const fileExtension = '.xlsx';
                const ws = XLSX.utils.json_to_sheet(data1);
                const wb = { Sheets: { obcanskaZnanost: ws }, SheetNames: ['obcanskaZnanost'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });

                FileSaver.saveAs(data, 'izvoz_obcanskaZnanost' + fileExtension);

                setShowSpinnerLoadingOZ1(false);
                setReportButtonDisabled(false);
                
            } else {
                setShowSpinnerLoadingOZ1(false);
                setReportButtonDisabled(false);
                setShowNoDataOZ1(true);
                
                setTimeout(() => {
                    setShowNoDataOZ1(false);
                }, 3000);
            }
        });
    }

    const exportXlsxObcanskeZnanostiSodelujoceOsebe = () => {
        fetchPOST1(`${izvozObcanskaZnanostSodelujoceOsebe}`, obcanskaZnanostSodelujoceOsebeInput)
        .then((data1) => {
            setShowSpinnerLoadingOZ2(true);
            setReportButtonDisabled(true);

            if (data1 !== 0) {

                //GET API KLIC PODATKE IN EXPORTAJ
                const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const fileExtension = '.xlsx';
                const ws = XLSX.utils.json_to_sheet(data1);
                const wb = { Sheets: { obcanskaZnanost: ws }, SheetNames: ['obcanskaZnanost'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });

                FileSaver.saveAs(data, 'izvoz_obcanskaZnanost' + fileExtension);

                setShowSpinnerLoadingOZ2(false);
                setReportButtonDisabled(false);
                
            } else {
                setShowSpinnerLoadingOZ2(false);
                setReportButtonDisabled(false);
                setShowNoDataOZ2(true);
                
                setTimeout(() => {
                    setShowNoDataOZ2(false);
                }, 3000);
            }
        });
    }

    const exportXlsxObcanskeZnanostiSkrbnik = () => {
        fetchPOST1(`${izvozObcanskaZnanostSkrbnik}`, obcanskaZnanostSkrbnikInput)
        .then((data1) => {
            setShowSpinnerLoadingOZ3(true);
            setReportButtonDisabled(true);

            if (data1 !== 0) {

                //GET API KLIC PODATKE IN EXPORTAJ
                const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const fileExtension = '.xlsx';
                const ws = XLSX.utils.json_to_sheet(data1);
                const wb = { Sheets: { obcanskaZnanost: ws }, SheetNames: ['obcanskaZnanost'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });

                FileSaver.saveAs(data, 'izvoz_obcanskaZnanost' + fileExtension);

                setShowSpinnerLoadingOZ3(false);
                setReportButtonDisabled(false);
                
            } else {
                setShowSpinnerLoadingOZ3(false);
                setReportButtonDisabled(false);
                setShowNoDataOZ3(true);
                
                setTimeout(() => {
                    setShowNoDataOZ3(false);
                }, 3000);
            }
        });
    }

    const exportXlsxObcanskeZnanostiVsi = () => {
        fetchPOST1(`${izvozObcanskaZnanostVsi}`, obcanskaZnanostVsiInput)
        .then((data1) => {
            setShowSpinnerLoadingOZ4(true);
            setReportButtonDisabled(true);

            if (data1 !== 0) {

                //GET API KLIC PODATKE IN EXPORTAJ
                const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const fileExtension = '.xlsx';
                const ws = XLSX.utils.json_to_sheet(data1);
                const wb = { Sheets: { obcanskaZnanost: ws }, SheetNames: ['obcanskaZnanost'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data = new Blob([excelBuffer], { type: fileType });

                FileSaver.saveAs(data, 'izvoz_obcanskaZnanost' + fileExtension);

                setShowSpinnerLoadingOZ4(false);
                setReportButtonDisabled(false);
                
            } else {
                setShowSpinnerLoadingOZ4(false);
                setReportButtonDisabled(false);
                setShowNoDataOZ4(true);
                
                setTimeout(() => {
                    setShowNoDataOZ4(false);
                }, 3000);
            }
        });
    }





    return (
        <Container fluid>
            <Row>
                <Col className='main-header font-weight-bold'>Izpisi</Col>
            </Row>
            <Row>
                <Col className='header-divider'>
                    <hr />
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row className="align-items-center">
                                <Col>
                                    Izpis projektov
                                </Col>
                                <Col>
                                    <Button disabled={reportButtonDisabled} className="float-end" onClick={exportXlsxProjectsAll}>Izvozi excel</Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {showSpinnerLoading && (
                                        <>
                                            <SpinnerLoading />
                                            <p className='text-center'>Poteka pridobivanje izpisa projektov...</p>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row className="align-items-center">
                                <Col>
                                    Izpis projektov s partnerji
                                </Col>
                                <Col>
                                    <Button disabled={reportButtonDisabled} className="float-end" onClick={exportXlsxProjectsPartners}>Izvozi excel</Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {showSpinnerLoadingPartnerji && (
                                        <>
                                            <SpinnerLoading />
                                            <p className='text-center'>Poteka pridobivanje izpisa projektov s partnerji...</p>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col className='main-header font-weight-bold'>Izpisi občanska znanost</Col>
            </Row>
            <Row className='mt-4'>
                <Col><b>Izpis projektov občanske znanosti (vodilne članice)</b></Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row className="align-items-center">
                                &nbsp;&nbsp;&nbsp;Datum od
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostSkrbnikInput({
                                                ...obcanskaZnanostSkrbnikInput,
                                                datumOD: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Datum do
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostSkrbnikInput({
                                                ...obcanskaZnanostSkrbnikInput,
                                                datumDO: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                <Col></Col>
                                <Col>
                                    {showNoDataOZ3
                                        ?
                                        <div className="float-end text-end">Izvoz neuspešen.<br/>Spremenite iskalne kriterije.</div>
                                        :
                                        <Button disabled={reportButtonDisabled} className="float-end" onClick={exportXlsxObcanskeZnanostiSkrbnik}>Izvozi excel</Button>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {showSpinnerLoadingOZ3 && (
                                        <>
                                            <SpinnerLoading />
                                            <p className='text-center'>Poteka pridobivanje izpisa občanske znanosti...</p>
                                        </>
                                    )}
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col><b>Izpis projektov za posamezno članico</b></Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row className="align-items-center">
                                &nbsp;&nbsp;&nbsp;Izberi članico
                                <Col className=''>
                                    <Select
                                        onChange={(selected) => {
                                            setObcanskaZnanostInput({
                                                ...obcanskaZnanostInput,
                                                clanica: selected.label
                                            });
                                        }}
                                        options={sifrantClanice}
                                        placeholder=""
                                    />
                                </Col>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Datum od
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostInput({
                                                ...obcanskaZnanostInput,
                                                datumOD: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Datum do
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostInput({
                                                ...obcanskaZnanostInput,
                                                datumDO: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                <Col></Col>
                                <Col>
                                    {showNoDataOZ1
                                        ?
                                        <div className="float-end text-end">Izvoz neuspešen.<br/>Spremenite iskalne kriterije.</div>
                                        :
                                        <Button disabled={reportButtonDisabled} className="float-end" onClick={exportXlsxObcanskeZnanosti}>Izvozi excel</Button>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {showSpinnerLoadingOZ1 && (
                                        <>
                                            <SpinnerLoading />
                                            <p className='text-center'>Poteka pridobivanje izpisa občanske znanosti...</p>
                                        </>
                                    )}
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col><b>Izpis projektov vseh sodelujočih članic</b></Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row className="align-items-center">
                                &nbsp;&nbsp;&nbsp;Datum od
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostVsiInput({
                                                ...obcanskaZnanostVsiInput,
                                                datumOD: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Datum do
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostVsiInput({
                                                ...obcanskaZnanostVsiInput,
                                                datumDO: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                <Col></Col>
                                <Col>
                                    {showNoDataOZ4
                                        ?
                                        <div className="float-end text-end">Izvoz neuspešen.<br/>Spremenite iskalne kriterije.</div>
                                        :
                                        <Button disabled={reportButtonDisabled} className="float-end" onClick={exportXlsxObcanskeZnanostiVsi}>Izvozi excel</Button>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {showSpinnerLoadingOZ4 && (
                                        <>
                                            <SpinnerLoading />
                                            <p className='text-center'>Poteka pridobivanje izpisa občanske znanosti...</p>
                                        </>
                                    )}
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col><b>Izpis projektov - sodelujoče osebe</b></Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row className="align-items-center">
                                &nbsp;&nbsp;&nbsp;Datum od
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostSodelujoceOsebeInput({
                                                ...obcanskaZnanostSodelujoceOsebeInput,
                                                datumOD: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Datum do
                                <Col>
                                    <Form.Control
                                        type="date"
                                        onChange={(e) => {
                                            setObcanskaZnanostSodelujoceOsebeInput({
                                                ...obcanskaZnanostSodelujoceOsebeInput,
                                                datumDO: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                                <Col></Col>
                                <Col></Col>
                                <Col>
                                    {showNoDataOZ2
                                        ?
                                        <div className="float-end text-end">Izvoz neuspešen.<br/>Spremenite iskalne kriterije.</div>
                                        :
                                        <Button disabled={reportButtonDisabled} className="float-end" onClick={exportXlsxObcanskeZnanostiSodelujoceOsebe}>Izvozi excel</Button>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {showSpinnerLoadingOZ2 && (
                                        <>
                                            <SpinnerLoading />
                                            <p className='text-center'>Poteka pridobivanje izpisa občanske znanosti...</p>
                                        </>
                                    )}
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Reports;